import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import IconButton from "@mui/material/IconButton";
import IconButton_styles from "./IconButton.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function IconButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else IconButton_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const IconButton_IconButton = (props)=>{
    const $ = c(19);
    let onClick;
    let rest;
    let size;
    let t0;
    let t1;
    if ($[0] !== props) {
        ({ onClick, blurOnClick: t0, testId: t1, size } = props), rest = _object_without_properties(props, [
            "onClick",
            "blurOnClick",
            "testId",
            "size"
        ]);
        $[0] = props;
        $[1] = onClick;
        $[2] = rest;
        $[3] = size;
        $[4] = t0;
        $[5] = t1;
    } else {
        onClick = $[1];
        rest = $[2];
        size = $[3];
        t0 = $[4];
        t1 = $[5];
    }
    const blurOnClick = void 0 === t0 ? true : t0;
    const testId = void 0 === t1 ? "icon-button-test-id" : t1;
    const { classes } = IconButton_styles();
    let t2;
    if ($[6] !== blurOnClick || $[7] !== onClick) {
        t2 = (e)=>{
            if (blurOnClick && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            null == onClick || onClick(e);
        };
        $[6] = blurOnClick;
        $[7] = onClick;
        $[8] = t2;
    } else t2 = $[8];
    const handleClick = t2;
    const t3 = props.className ? `${props.className} aqa_icon_button` : "aqa_icon_button";
    const t4 = "extraSmall" === size && classes.extraSmall;
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = classnames(t3, t4);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const t6 = "extraSmall" === size ? "small" : size;
    let t7;
    if ($[12] !== handleClick || $[13] !== props.children || $[14] !== rest || $[15] !== t5 || $[16] !== t6 || $[17] !== testId) {
        t7 = /*#__PURE__*/ jsx(IconButton, _object_spread_props(_object_spread({}, rest), {
            type: "button",
            onClick: handleClick,
            className: t5,
            size: t6,
            "data-testid": testId,
            children: props.children
        }));
        $[12] = handleClick;
        $[13] = props.children;
        $[14] = rest;
        $[15] = t5;
        $[16] = t6;
        $[17] = testId;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
};
export { IconButton_IconButton as IconButton };
